import 'jspolyfill-array.prototype.find';
import React from 'react';
import { render, hydrate } from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
  registerServiceWorker();
} else {
  render(<App />, rootElement);
}



// WEBPACK FOOTER //
// ./src/index.js